export default __webpack_public_path__ + "static/media/graf-banner-why.dc929827.svg";